import { DatePipe, DecimalPipe, NgClass } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SessionService } from '@app/core/session.service';
import { UsageService } from '@app/core/usage.service';
import { WorkspaceService } from '@app/core/workspace.service';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { ToastService } from '@app/core/toast.service';

@Component({
  selector: 'app-credit-meter',
  standalone:true,
  imports: [DecimalPipe, NgClass, CardModule, DatePipe, RouterLink, TooltipModule],
  templateUrl: './credit-meter.component.html',
  styleUrl: './credit-meter.component.scss'
})
export class CreditMeterComponent {
  sessionService = inject(SessionService);
  usageService = inject(UsageService);
  workspaceService = inject(WorkspaceService);
  toastService = inject(ToastService);

  viewMode = input<'navbar' | 'billing'>('navbar');
  router = inject(Router);


  renewalDate = this.usageService.renewalDate;
  creditsUsed = this.usageService.creditsUsed;
  prepaidCredits = this.usageService.prepaidCredits;
  creditLimitFromSubscription = this.usageService.creditLimitFromSubscription;
  totalCreditLimit = this.usageService.totalCreditLimit;
  usedPercentage = this.usageService.usedPercentage;
  prepaidThresholdPercentage = this.usageService.prepaidThresholdPercentage;
  displayBarPercentage = this.usageService.displayBarPercentage;
  barFillColor = this.usageService.barFillColor;

  async refresh() {
    try {
      // Force a server-side re-sync of the usage summary and patch the fresh
      // balance straight into the active workspace. Reads the lean
      // `usage/balance` endpoint (backed by `usage_summaries`), not the full
      // billing account. Live updates otherwise arrive via the realtime
      // subscription on `usage_summaries`.
      await this.workspaceService.refreshBalance();
      this.toastService.add({severity:'success', summary:'Usage Refreshed', detail:'Your usage has been refreshed.'});
    } catch {
      this.toastService.add({severity:'error', summary:'Refresh Failed', detail:'Could not refresh usage. Please try again.'});
    }
  }

}
